function getNewsletterConfig() {
  if (typeof window.rocketNewsletter === "object" && window.rocketNewsletter) {
    return window.rocketNewsletter;
  }

  return null;
}

function isValidEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
}

function getMessageEl(form) {
  let message = form.querySelector("[data-newsletter-message]");

  if (!message) {
    message = document.createElement("p");
    message.className = "newsletter-form__message";
    message.setAttribute("data-newsletter-message", "");
    message.setAttribute("role", "status");
    message.setAttribute("aria-live", "polite");
    form.appendChild(message);
  }

  return message;
}

function setFormState(form, state) {
  const submit = form.querySelector("[type='submit']");
  const fields = form.querySelectorAll("input, button, textarea, select");

  fields.forEach((field) => {
    if (field.type === "hidden" || field.name === "company") {
      return;
    }
    field.disabled = state === "loading" || (state === "success" && field !== submit);
  });

  if (submit) {
    submit.disabled = state === "loading" || state === "success";
    submit.setAttribute("aria-busy", state === "loading" ? "true" : "false");
  }

  form.classList.toggle("is-loading", state === "loading");
  form.classList.toggle("is-success", state === "success");
  form.classList.toggle("is-error", state === "error");
}

function showMessage(form, text, type) {
  const message = getMessageEl(form);
  message.textContent = text;
  message.classList.remove("is-success", "is-error");
  if (type) {
    message.classList.add(type === "success" ? "is-success" : "is-error");
  }
}

function requiresNames(form) {
  return form.hasAttribute("data-newsletter-require-names");
}

function shouldCombineNames(form) {
  return form.hasAttribute("data-newsletter-combine-names");
}

function getNewsletterMessage(config, key) {
  return config?.messages?.[key] || "";
}

async function submitNewsletterForm(form) {
  const config = getNewsletterConfig();
  const emailInput = form.querySelector("input[name='email'], input[type='email']");
  const firstNameInput = form.querySelector("input[name='first_name']");
  const lastNameInput = form.querySelector("input[name='last_name']");
  const email = emailInput ? String(emailInput.value || "").trim() : "";
  const rawFirstName = firstNameInput ? String(firstNameInput.value || "").trim() : "";
  const rawLastName = lastNameInput ? String(lastNameInput.value || "").trim() : "";
  let firstName = rawFirstName;
  let lastName = rawLastName;

  if (requiresNames(form)) {
    if (shouldCombineNames(form)) {
      if (rawFirstName === "" || rawLastName === "") {
        setFormState(form, "error");
        showMessage(form, getNewsletterMessage(config, "invalid_name"), "error");
        (rawFirstName === "" ? firstNameInput : lastNameInput)?.focus();
        return;
      }
    } else if (firstName === "" || lastName === "") {
      setFormState(form, "error");
      showMessage(form, getNewsletterMessage(config, "invalid_name"), "error");
      (firstName === "" ? firstNameInput : lastNameInput)?.focus();
      return;
    }
  }

  if (shouldCombineNames(form)) {
    firstName = [rawFirstName, rawLastName].filter(Boolean).join(" ");
    lastName = "";
  }

  if (!isValidEmail(email)) {
    setFormState(form, "error");
    showMessage(form, getNewsletterMessage(config, "invalid_email"), "error");
    emailInput?.focus();
    return;
  }

  if (!config?.ajax_url || !config?.nonce) {
    setFormState(form, "error");
    showMessage(form, getNewsletterMessage(config, "generic_error"), "error");
    return;
  }

  setFormState(form, "loading");
  showMessage(form, getNewsletterMessage(config, "submitting"), null);

  const body = new FormData();
  body.append("action", config.action || "rocket_newsletter_subscribe");
  body.append("nonce", config.nonce);
  body.append("email", email);

  if (firstName !== "") {
    body.append("first_name", firstName);
  }
  if (lastName !== "") {
    body.append("last_name", lastName);
  }

  const source = form.getAttribute("data-newsletter-source");
  if (source) {
    body.append("source", source);
  }

  if (config.lang) {
    body.append("lang", config.lang);
  }

  if (typeof window.location?.href === "string" && window.location.href !== "") {
    body.append("page_url", window.location.href);
  }

  const honeypot = form.querySelector("input[name='company']");
  if (honeypot) {
    body.append("company", honeypot.value);
  }

  try {
    const response = await fetch(config.ajax_url, {
      method: "POST",
      credentials: "same-origin",
      body,
    });

    const payload = await response.json();

    if (!response.ok || !payload?.success) {
      throw new Error(payload?.data?.message || getNewsletterMessage(config, "generic_error"));
    }

    setFormState(form, "success");
    showMessage(form, payload.data?.message || getNewsletterMessage(config, "success"), "success");
    form.dispatchEvent(
      new CustomEvent("newsletter:subscribed", {
        bubbles: true,
        detail: payload.data || {},
      }),
    );
  } catch (error) {
    setFormState(form, "error");
    showMessage(
      form,
      error?.message || getNewsletterMessage(config, "generic_error"),
      "error",
    );
  }
}

export function bindNewsletterForms(root) {
  const scope = root && root.querySelectorAll ? root : document;
  const selector = ".newsletter-cta__form, .single-post-newsletter__form, .newsletter-popup__form";

  scope.querySelectorAll(selector).forEach((form) => {
    if (form.__rocketNewsletterBound) {
      return;
    }

    form.__rocketNewsletterBound = true;

    form.addEventListener("submit", (event) => {
      event.preventDefault();
      submitNewsletterForm(form);
    });

    const submit = form.querySelector("[type='submit']");
    if (submit) {
      submit.addEventListener("click", (event) => {
        if (submit.type !== "submit") {
          event.preventDefault();
          submitNewsletterForm(form);
        }
      });
    }
  });
}
